import { Component, ChangeDetectionStrategy, inject, signal } from '@angular/core';
import { RouterOutlet, Router, NavigationEnd } from '@angular/router';
import { HeaderComponent } from './components/header/header.component';
import { filter } from 'rxjs';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, HeaderComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    @if (!isRegistrationRoute()) {
      <app-header />
    }
    <main><router-outlet /></main>
  `,
  styles: [`main { min-height: calc(100vh - 60px); }`],
})
export class AppComponent {
  private router = inject(Router);
  isRegistrationRoute = signal(false);

  constructor() {
    this.router.events.pipe(
      filter((e): e is NavigationEnd => e instanceof NavigationEnd)
    ).subscribe((e) => {
      this.isRegistrationRoute.set(e.urlAfterRedirects === '/registration' || e.urlAfterRedirects.startsWith('/driver/'));
    });
  }
}
